<template>
  <div class="nav">
    <router-link class="nav-item" to="/goods">
      點菜
      <i class="line"></i>
    </router-link>
    <router-link class="nav-item" to="/ratings">
      評價 ( {{ commentNum }} )
      <i class="line"></i>
    </router-link>
    <router-link class="nav-item" to="/seller">
      商家
      <i class="line"></i>
    </router-link>

    <!-- <router-link class="nav-item goods" to="../Goods/Goods">點菜</router-link>
    <router-link class="nav-item ratings" to="../Ratings/Ratings">評價</router-link>
    <router-link class="nav-item seller" to="../Seller/Seller">商家</router-link> -->
  </div>
</template>
<script>
  export default {
      props: {
        commentNum:{
          type: Number,
          default: 0,
        }
      }
  }
</script>
<style>
  .nav{
    display: flex;
    width: 100%;
    height: 40px;
    line-height:40px;

    border-bottom:1px solid #e4e4e4;
  }
  .nav .nav-item{
    flex: 1;
    text-align: center;
    font-size:13px;
    color:#666666;
    text-decoration: none;

    position: relative;
  }
  .nav .active{
    color: #FFBB22;
  }
  .nav .active .line{
    width: 20px;
    height: 2px;
    display: inline-block;
    background: #FFBB22;

    position:absolute;
    left: 50%;
    bottom: 0;
    margin-left:-10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/nav/Nav.vue